import React from 'react';
import Image from 'next/image';

import { Text } from '../Text';
import { BlockContainer, Layout, Column } from '../Layout';

import { PressItem } from './styles';

import { featuredPress } from '../../data/featuredPress';

export function AsFeaturedOn() {
  return (
    <BlockContainer
      // backgroundColor="asFeaturedOnBg"
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid="asFeaturedOn"
      data-testid="asFeaturedOn"
    >
      <Layout gutter="sm" padding={{ 0: ['l', 0], tablet: ['xl', 0] }}>
        <Column size={12} justifyContent="center">
          <Text
            as="h2"
            fontSize={{ 0: 'sm', desktop: 'xl' }}
            fontWeight="500"
            colour="white"
            textAlign="center"
          >
            As featured on
          </Text>
        </Column>

        <Column
          size={12}
          flexWrap="wrap"
          justifyContent="center"
          alignItems="center"
        >
          {featuredPress.map(({ logoSrc, altText }) => (
            <PressItem
              key={altText}
              margin={{ 0: ['m', 0], desktop: ['ml', 0] }}
              padding={{ 0: [0, 's'], desktop: [0, 'm'] }}
            >
              <Image src={logoSrc} alt={altText} data-testid="featuredOnIcon" />
            </PressItem>
          ))}
        </Column>
      </Layout>
    </BlockContainer>
  );
}
